const timeline_data = [
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-1-17-04-to-23-04.pdf",
    startDate: "17 April",
    endDate: "23 April",
    week: 1,
    description: [
      {
        subtitle:
          "Initiation of the culture of C. reinhardtii and S. meliloti\n",
        lines: [],
      },
      {
        subtitle: "S. meliloti maintenance passages",
        lines: [],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-2-24-04-to-30-04.pdf",
    startDate: "24 April",
    endDate: "30 April",
    week: 2,
    description: [
      {
        subtitle: "Cell Count and Maintenance",
        lines: [
          " The relationship between OD750 and C. reinhardtii cell number was determined. Maintenance procedures were conducted for both C. reinhardtii and S. meliloti, including bacteria enumeration for S. meliloti.\n",
        ],
      },
      {
        subtitle: "Monitoring, Enumeration, Maintenance ",
        lines: [
          " Continuous monitoring of C. reinhardtii maintenance cultures occurred, alongside regular counting of enumeration plates and passages.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-3-01-05-to-07-05.pdf",
    startDate: "01 May",
    endDate: "07 May",
    week: 3,
    description: [
      {
        subtitle: "S. meliloti Culture Testing",
        lines: [" Conducted streptomycin test on S. meliloti culture.\n"],
      },
      {
        subtitle: "Flask Measurement and Monitoring",
        lines: [
          " Measured OD750 of specific flasks. Monitored S. meliloti cultures for several days.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-4-08-05-to-14-05.pdf",
    startDate: "08 May",
    endDate: "14 May",
    week: 4,
    description: [
      {
        subtitle: "S. Meliloti Culture Testing",
        lines: [" Conducted streptomycin test on S. meliloti culture.\n"],
      },
      {
        subtitle: "Flask Measurement and Monitoring",
        lines: [
          " Measured OD750 of specific flasks. Monitored S. meliloti cultures from 10/05 for several days.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-5-15-05-to-21-05.pdf",
    startDate: "15 May",
    endDate: "21 May",
    week: 5,
    description: [
      {
        subtitle: "S. Meliloti Cultivation",
        lines: [
          " Passage S. meliloti culture.\n",
          " Started new S. meliloti culture from stored tubes.\n",
          " Cultivated S. meliloti on plates from tubes provided by Dr. Bruand.\n",
          " Adaptation started in simili urine and wastewater media.\n",
        ],
      },
      {
        subtitle: "Media Preparation and Adjustment",
        lines: [
          " Prepared simili urine media.\n",
          " Adjusted pH of simili urine and wastewater media.\n",
        ],
      },
      {
        subtitle: "C. Reinhardtii Maintenance",
        lines: [
          " Passed C. reinhardtii maintenance.\n",
          " Cultivated C. reinhardtii in simili urine and wastewater media.\n",
        ],
      },
      {
        subtitle: "Cultural Monitoring",
        lines: [
          " Monitored cultures in simili media for both S. meliloti and C. reinhardtii.\nWeek 6\n",
        ],
      },
      {
        subtitle: "Daily Growth Measurements",
        lines: [
          " Conducted daily measurements of C. reinhardtii growth for adaptation to synthetic wastewater/urine.\n",
          " Conducted daily measurements of S. meliloti growth for adaptation to synthetic wastewater/urine.\n",
        ],
      },
      {
        subtitle: "Passage and Adaptation Protocols",
        lines: [
          " Passed cultures for both C. reinhardtii and S. meliloti according to adaptation protocols to synthetic wastewater/urine conditions.\n",
          " Adaptation protocols were consistently followed for both organisms.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-6-22-05-to-28-05.pdf",
    startDate: "22 May",
    endDate: "28 May",
    week: 6,
    description: [
      {
        subtitle: "Daily Growth Measurements and Adaptation Protocols",
        lines: [
          " Conducted daily growth measurements for C. reinhardtii and S. meliloti as part of the\nadaptation protocols to synthetic wastewater/urine conditions.\n",
          " Continued adaptation protocols for both organisms consistently.\n",
        ],
      },
      {
        subtitle: "Bacterial identification",
        lines: [
          " Conducted a Gram test of bacteria during the adaptation process.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-7-29-05-to-04-06.pdf",
    startDate: "29 May",
    endDate: "04 June",
    week: 7,
    description: [
      {
        subtitle: "Daily Growth Measurements and Adaptation Protocols",
        lines: [
          " Monitored C. reinhardtii and S. meliloti daily growth as part of the adaptation protocols to synthetic wastewater/urine conditions.\n",
        ],
      },
      {
        subtitle: "Contamination Tests",
        lines: [
          " Conducted contamination tests for urine condition in the adaptation protocol.\n",
          " Performed contamination tests for synthetic urine media.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-8-05-06-to-11-06.pdf",
    startDate: "05 June",
    endDate: "11 June",
    week: 8,
    description: [
      {
        subtitle: "Contamination Tests and Adaptation Protocols",
        lines: [
          " Conducted contamination test for C. reinhardtii's flask.\n",
          " Monitored daily growth of C. reinhardtii for adaptation to synthetic wastewater.\n",
          " Started synthetic urine adaptation protocol (50% Urine/50% TAP).\n",
          " Continued daily growth measurements for C. reinhardtii adaptation to synthetic wastewater/urine protocols.\n",
          " Initiated synthetic urine adaptation protocol (25% Urine/75% TAP).",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-9-12-06-to-18-06.pdf",
    startDate: "12 June",
    endDate: "18 June",
    week: 9,
    description: [
      {
        subtitle: "Adaptation Protocols and Daily Measurements",
        lines: [
          " Conducted daily growth measurements of C. reinhardtii for the adaptation to synthetic wastewater/urine protocol.\n",
          " Continued monitoring of S. meliloti maintenance.\n",
          " Passed C. reinhardtii maintenance for both TAP and synthetic wastewater adaptation protocols.\n",
        ],
      },
      {
        subtitle: "Maintenance and Cultivation",
        lines: [
          " Passed S. meliloti maintenance.\n",
          " Created a S. meliloti bank.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-10-19-06-to-25-06.pdf",
    startDate: "19 June",
    endDate: "25 June",
    week: 10,
    description: [
      {
        subtitle: "Media Analysis and Sterility Checks",
        lines: [
          " Analyzed synthetic urine media.\n",
          " Conducted a Gram staining test on the S. meliloti bank and performed sterility analysis of TAP media.\n",
          " Checked sterility of TAP media.\n",
        ],
      },
      {
        subtitle: "Adaptation Protocols and Cultivation",
        lines: [
          " Started adaptation protocol for S. meliloti to synthetic urine and synthetic wastewater.\n",
          " Began proof of C. reinhardtii growth in synthetic wastewater.\n",
          " Monitored adaptation protocol of S. meliloti to synthetic urine and synthetic wastewater, and C. reinhardtii growth in synthetic wastewater.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-11-26-06-to-2-07.pdf",
    startDate: "26 June",
    endDate: "02 July",
    week: 11,
    description: [
      {
        subtitle: "Adaptation Protocols and Cultivation",
        lines: [
          " Monitored adaptation protocol of S. meliloti to synthetic urine and synthetic wastewater.\n",
          " Monitored C. reinhardtii growth in synthetic wastewater and initiated adaptation protocol to synthetic urine.\n",
          " Conducted tests to enhance C. reinhardtii growth in synthetic wastewater and synthetic urine.\n",
        ],
      },
      {
        subtitle: "Media Preparation and Experiments",
        lines: [
          " Created new synthetic urine media.\n",
          " Conducted E. coli Dh5",
          "α transformations by heat shock with specific plasmids.\n",
          " Performed experiments and minipreparation to optimize C. reinhardtii growth in synthetic wastewater and synthetic urine.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-12-3-07-to-9-07.pdf",
    startDate: "03 July",
    endDate: "09 July",
    week: 12,
    description: [
      {
        subtitle: "Transfection and Plasmid Backbone Manipulation",
        lines: [
          " Transfected E. coli with plasmid backbone pSB1K3 multiple times.\n",
          " Transferred E. coli transfected with pSB1K3 into lysogenic broth liquid medium.\n",
        ],
      },
      {
        subtitle: "Coculture Assay and Adaptation Protocols",
        lines: [
          " Launched a co",
          "culture assay between S. meliloti and C. reinhardtii in lysogenic broth and TAP growth media.\n",
          " Monitored adaptation of S. meliloti and C. reinhardtii in synthetic urine and wastewater media.\n",
        ],
      },
      {
        subtitle: "Media Analysis and C. Reinhardtii Growth Studies",
        lines: [
          " Conducted miniprep of pSB1K3 plasmid backbone.\n",
          " Analyzed C. reinhardtii growth in a medium containing 50% LB and 50% TAP.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-13-10-07-to-16-07.pdf",
    startDate: "10 July",
    endDate: "16 July",
    week: 13,
    description: [
      {
        subtitle: "Genetic Engineering and Transformation",
        lines: [
          " Transfected E. coli with PsaD gene promoter and terminator.\n",
          " Conducted Golden Gate assembly with 1 intron AOX gene and transformed E. coli with the resulting construct.\n",
          " Digested HaO",
          "AmoA insert and ligated it with plasmid backbone pSB1K3.\n",
        ],
      },
      {
        subtitle: "Coculture Trials and Adaptation Studies",
        lines: [
          " Monitored co",
          "culture trial between S. meliloti and C. reinhardtii in lysogenic broth, TAP, synthetic urine, and synthetic wastewater media.\n",
          " Launched co",
          "culture assay between S. meliloti and C. reinhardtii in synthetic\nwastewater medium.\n",
          " Analyzed C. reinhardtii growth in various media compositions (50% LB and 50% TAP).\n",
        ],
      },
      {
        subtitle: "Maintenance and Monitoring",
        lines: [
          " Conducted daily measurements of S. meliloti growth for adaptation to urine.\n",
          " Maintained and monitored co",
          "culture conditions.\n",
        ],
      },
      {
        subtitle: "Plasmid Manipulation",
        lines: [
          " Digested and ligated plasmid backbone pSB1K3 multiple times.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-14-17-07-to-23-07.pdf",
    startDate: "17 July",
    endDate: "23 July",
    week: 14,
    description: [
      {
        subtitle: "Genetic Engineering",
        lines: [
          " Plasmid analysis (AOX_1_intron) and DH5α transformation with AOX_1introncontaining plasmids.\n",
        ],
      },
      {
        subtitle: "Coculture and Growth Monitoring",
        lines: [
          " Counted Chlamydomonas mallassez and S. meliloti in the coculture.\n",
          " Monitored daily growth of C. reinhardtii in maintenance and co",
          "culture with S. meliloti.\n",
        ],
      },
      {
        subtitle: "Genetic Engineering and Analysis",
        lines: [
          " Assembled AOX_3introns_V3 using Golden Gate with pBMS810.\n",
          " Transformed DH5α with AOX_1intron and AOX_3introns plasmids.\n",
          " Conducted various DNA analyses and PCR tests.\n",
          " Maintained C. reinhardtii cultures.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-15-24-07-to-30-07.pdf",
    startDate: "24 July",
    endDate: "30 July",
    week: 15,
    description: [
      {
        subtitle: "Genetic Experiments",
        lines: [
          " Conducted genetic assays, including AOX_1_intron and AOX_3introns_V3 golden gate digestion and transformation.\n",
          " Performed plasmid purifications, digestions, and ligations.\n",
          " Analyzed agarose gel electrophoresis results.\n",
          " Conducted PCR assays on introns like HAO AMOA and pSB1K3 of IGEM parts. Coculture Monitoring",
        ],
      },
      {
        subtitle: "Additional Experiments",
        lines: [
          " Tested immunofluorescence with Mitotracker Red CMXRos.\n",
          " Prepared and analyzed synthetic urine and wastewater media.\n",
          " Conducted passage and adaptation protocols for both C. Reinhardtii and S. meliloti.\n",
          " Performed pH adjustments and media sterilization tests.\n",
          " Transformed E. coli with various plasmids, such as pSB1K3 and PsaD gene promoters and\nterminators.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-16-31-07-to-06-08.pdf",
    startDate: "31 July",
    endDate: "06 August",
    week: 16,
    description: [
      {
        subtitle: "Genetic Experiments",
        lines: [
          " Performed multiple digestions and ligations involving pPSAD promoter and AOX_3introns_V3 gene, AOX_3introns_3F, AOX_1intron, and pBMS810 plasmids.\n",
          " Conducted electrophoresis to analyze the ligations and PCR products.\n",
          " Purified and analyzed various PCR products, including AOX_3introns_3F and AOX_3introns_V3.\n",
          " Built AOX_1intron_plasmid and performed PCR for tPSAD terminator and AOX_3introns_3F gene.\n",
          " Conducted E. coli DH5",
          "α transformations using AmoA_HAO__idtKana plasmid with multiple heat shock protocols.\n",
        ],
      },
      {
        subtitle: "Coculture and Growth Analysis",
        lines: [
          " Monitored co",
          "culture growth and analyzed results.\n",
          " Conducted freezing of E. coli DH5",
          "α with AmoA_HAO__idtKana plasmid and prepared AOX_1intron_plasmid.\n",
          " Analyzed the freezing process and conducted bacterial enumerations on specific dates.\n",
          " Performed analysis and purification of tPSAD and AOX_3introns_3F PCR products.\n",
          " Conducted ligation of pPSAD with AOX_1intron and tPSAD, followed by transformations using\nheat shock protocols with specific tubes.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-17-7-08-to-13-08.pdf",
    week: 17,
    description: [
      {
        subtitle: "Genetic Experiments",
        lines: [
          " Digested and ligated pPSAD, tPSAD, and AOX_1intron using BsaI enzyme.\n",
          " Digested pBMS810 and performed final ligation.\n",
          " Transfected E. coli with HAO",
          "AmoA plasmid.\n",
          " Electroporated S. meliloti with HAO",
          "AmoA plasmid.\n",
          " Spread HAO",
          "AmoA",
          "transfected S. meliloti on agar plates for growth.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-18-14-08-to-20-08.pdf",
    startDate: "14 August",
    endDate: "20 August",
    week: 18,
    description: [
      {
        subtitle: "Genetic Experiments",
        lines: [
          " Electroporation of S. meliloti.\n",
          " Transformation of E. coli DH5α with various plasmids (HAO",
          "AMOA, AOX_3introns_3f, AOX_3introns_V3).\n",
          " Digestion and migration experiments, including AOX_1intron ligations and Miniprep products.\n",
          " Various DNA extraction techniques, including Monarch Plasmid Extraction Kit, used for sample preparation.\n",
          " AOX GoldenGates reactions performed.\n",
          " Transformation of E. coli DH5α with GoldenGates products.\n",
        ],
      },
      {
        subtitle: "Coculture and Growth Analysis",
        lines: [
          " Monitoring of cocultures involving S. meliloti, E. coli DH5α, and C. reinhardtii.\n",
          " Phosphate/Nitrate depollution tests conducted using C. reinhardtii in synthetic wastewater and TAP media.\n",
          " Adaptation and maintenance of C. reinhardtii cultures in synthetic wastewater due to contamination.",
        ],
      },
    ],
  },
  {
    link: "https://static.igem.wiki/teams/4577/wiki/project/notebook/week-19-21-08-to-27-08.pdf",
    startDate: "21 August",
    endDate: "27 August",
    week: 19,
    description: [
      {
        subtitle: "Molecular Manipulation",
        lines: [
          " Conducted digestion of pPSAD, tPSAD, and AOX_1intron with BsaI enzymes.\n",
          " Ligated AOX_1intron, pPSAD, and tPSAD fragments after digestion.\n",
        ],
      },
      {
        subtitle: "Plasmid Manipulation and Transformation",
        lines: [
          " Digested pBMS810 with BsaI and performed the final ligation.\n",
          " Transfected E. coli with the final ligation product.\n",
          " Initiated a culture of E. coli transfected with HAO",
          "AmoA plasmid.\n",
        ],
      },
      {
        subtitle: "S. Meliloti Transformation",
        lines: [
          " Conducted miniprep of HAO",
          "AmoA plasmid.\n",
          " Performed electroporation of S. meliloti with the transformed plasmid.\n",
          " Spread S. meliloti transfected with HAO",
          "AmoA on plates for further analysis.",
        ],
      },
    ],
  },
];

export { timeline_data };
